import CardDetailWorkout from 'components/molecules/Card/Detail/Workout';
import i18n from 'helper/i18n';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getExercises, getSelectedExercise, getSelectedExercisePreviewImage } from 'store/exercises';
import { actionCreators as exercisesAC } from 'store/exercises';
import { actionCreators as optionalProgramItemsAC } from 'store/optionalProgramItems';
import { getWeight } from 'store/profile';
import { actionCreators as itemAC } from 'store/programItems';
import {
	getSelectedCalories,
	getSelectedDuration,
	getSelectedExerciseId,
	getWorkoutCalories,
} from 'store/programItems';
import { actionCreators as transientPoolAC, getDayRef, getProgramItemRef } from 'store/transientPoolState';

// Sequences
import withSequenceState from 'components/hoc/withSequenceState';
import Sequences from 'defs/sequences';

const mapStateToProps = (state: any, ownProps: any) => {
	const selectedExerciseId = getSelectedExerciseId(state, ownProps.id);

	return {
		title: i18n('react.impulsCoach.components.cardDetail.workout.custom.title'),
		isDone: false,
		uiState: 'detail',
		// intensity: getIntensity(state, ownProps.id),
		energyKcal: ((calories: number, profileWeight: number) => {
			if (!calories || !profileWeight) {
				return 0;
			}
			return calories * profileWeight;
		})(getWorkoutCalories(state, ownProps.id), getWeight(state) as any),
		// totalDuration: getWorkoutTotalDuration(state, ownProps.id),
		// descriptionShort: getDescriptionShort(state, ownProps.id),
		// description: getDescription(state, ownProps.id),
		// toolList: getToolList(state, ownProps.id),
		// tableList: { items: getWorkoutSets(state, ownProps.id) },
		// repetitionsPerWorkoutSet: getRepetitionsPerWorkoutSet(state, ownProps.id),
		// pausePerWorkoutSet: getPausePerWorkoutSet(state, ownProps.id),
		// Custom Workout
		selectedExerciseId,
		selectedExercisePreviewImage: getSelectedExercisePreviewImage(state, ownProps.id),
		selectedExercise: getSelectedExercise(state, ownProps.id),
		selectedCalories: getSelectedCalories(state, ownProps.id),
		selectedDuration: getSelectedDuration(state, ownProps.id),
		dayRef: getDayRef(state),
		programItemRef: getProgramItemRef(state),
		weight: getWeight(state),
		exercises: getExercises(state),
		isCustom: true,
	};
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(
		{
			...exercisesAC,
			...itemAC,
			doCreateCustomFromOptional: optionalProgramItemsAC.doCreateCustomFromOptional,
			doSetProgramItemRef: transientPoolAC.doSetProgramItemRef,
		},
		dispatch
	);
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withSequenceState(CardDetailWorkout, [Sequences.CARD_IS_CHECKING, Sequences.CARD_IS_POSTPONING]) as any);
